"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gap = exports.Letter = void 0;
const BoxComponentWithImg_1 = require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg");
const styled_components_1 = __importDefault(require("styled-components"));
exports.Letter = (0, styled_components_1.default)(BoxComponentWithImg_1.TextBox) `
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px;
  display: flex;
  color: white;
  font-family: Arial, sans-serif;
  border-radius: 3px;
  background-color: ${({ disabled }) => (disabled ? 'transparent' : '#693fe8')};
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: ${({ disabled }) => (disabled ? 'transparent' : '#4d1fca')};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  }
`;
exports.Gap = styled_components_1.default.span `
  @keyframes carriageIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes carriageOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  animation: ${({ selected, filled }) => selected && !filled ? 'carriageIn .75s, carriageOut .75s infinite' : 'unset'};
  animation-fill-mode: forwards;
  word-break: keep-all;
  white-space: nowrap;
  color: ${({ selected }) => (selected ? 'orange' : 'inherit')};
  border-bottom: ${({ filled }) => (filled ? '6px solid white' : 'none')};
  border-bottom-color: ${({ isCorrect, filled }) => isCorrect ? 'green' : filled ? 'red' : 'inherit'};
  padding-bottom: 5px;
  width: fit-content;
  box-sizing: border-box;
  line-height: 37px;
  cursor: pointer;
  font-family: Arial, sans-serif;
`;
